import { Component } from '@angular/core';
import { Subject } from 'rxjs';

import { LoaderService } from '../../../services/loader.service';
import { SharedDataService } from '../../../services/shared-data.service';

@Component({
    selector: 'con-app-loader',
    templateUrl: './con-app-loader.html',
    styleUrls: ['./con-app-loader.scss'],
    standalone: false
})
export class LoaderComponent {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  
  constructor(private readonly loaderService: LoaderService, private readonly sharedDataService: SharedDataService){}
}